import React from 'react';
import { XIcon, GlobeIcon, BellIcon, PaletteIcon } from 'lucide-react';
import { useOrganization } from '../contexts/OrganizationContext';
interface SettingsModalProps {
  isOpen: boolean;
  onClose: () => void;
}
export function SettingsModal({
  isOpen,
  onClose
}: SettingsModalProps) {
  const {
    language,
    setLanguage,
    t
  } = useOrganization();
  if (!isOpen) return null;
  const languages = [{
    code: 'en' as const,
    label: 'English',
    flag: '🇬🇧'
  }, {
    code: 'uk' as const,
    label: 'Українська',
    flag: '🇺🇦'
  }, {
    code: 'fr' as const,
    label: 'Français',
    flag: '🇫🇷'
  }];
  return <>
      <div className="modal-backdrop" onClick={onClose} style={{
      animation: 'fadeIn 200ms cubic-bezier(0.4, 0, 0.2, 1)'
    }} data-id="element-375" />
      <div className="modal-container" data-id="element-376">
        <div className="modal-content bg-white rounded-2xl shadow-2xl max-w-2xl w-full max-h-[90vh] overflow-hidden" style={{
        animation: 'scaleIn 200ms cubic-bezier(0.34, 1.56, 0.64, 1)'
      }} data-id="element-377">
          {/* Header with Premium Gradient */}
          <div className="bg-gradient-to-r from-blue-600 to-blue-700 px-6 py-5 flex items-center justify-between" data-id="element-378">
            <div className="flex items-center gap-3" data-id="element-379">
              <div className="w-10 h-10 bg-white/20 rounded-lg flex items-center justify-center transition-transform duration-200 hover:scale-110" data-id="element-380">
                <PaletteIcon className="w-5 h-5 text-white" data-id="element-381" />
              </div>
              <h2 className="text-2xl font-bold text-white" data-id="element-382">
                {t.settingsTitle}
              </h2>
            </div>
            <button onClick={onClose} className="w-10 h-10 flex items-center justify-center rounded-lg hover:bg-white/10 transition-all duration-200 text-white hover:scale-110 active:scale-95" aria-label="Close" data-id="element-383">
              <XIcon className="w-5 h-5" data-id="element-384" />
            </button>
          </div>
          {/* Content with Smooth Scroll */}
          <div className="p-6 overflow-y-auto max-h-[calc(90vh-80px)] custom-scrollbar" data-id="element-385">
            {/* Language Section */}
            <div className="mb-8 animate-slide-in-up" style={{
            animationDelay: '50ms'
          }} data-id="element-386">
              <div className="flex items-center gap-2 mb-4" data-id="element-387">
                <GlobeIcon className="w-5 h-5 text-blue-600" data-id="element-388" />
                <h3 className="text-lg font-semibold text-gray-900" data-id="element-389">
                  {t.languageLabel}
                </h3>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-3" data-id="element-390">
                {languages.map((lang, index) => <button key={lang.code} onClick={() => setLanguage(lang.code)} className={`p-4 rounded-xl border-2 transition-all duration-200 text-left ${language === lang.code ? 'bg-blue-50 border-blue-500 shadow-md scale-105' : 'bg-white border-gray-200 hover:border-blue-300 hover:shadow-sm hover:scale-102 active:scale-98'}`} style={{
                animation: 'scaleIn 200ms cubic-bezier(0.34, 1.56, 0.64, 1)',
                animationDelay: `${100 + index * 50}ms`
              }} data-id="element-391">
                    <div className="flex items-center gap-3" data-id="element-392">
                      <span className="text-3xl transition-transform duration-200 hover:scale-110" data-id="element-393">
                        {lang.flag}
                      </span>
                      <div className="flex-1" data-id="element-394">
                        <div className={`font-semibold ${language === lang.code ? 'text-blue-700' : 'text-gray-900'}`} data-id="element-395">
                          {lang.label}
                        </div>
                        <div className="text-xs text-gray-500 uppercase mt-0.5" data-id="element-396">
                          {lang.code}
                        </div>
                      </div>
                      {language === lang.code && <div className="w-2 h-2 bg-blue-600 rounded-full animate-pulse" data-id="element-397" />}
                    </div>
                  </button>)}
              </div>
            </div>
            {/* Notifications Section */}
            <div className="mb-8 animate-slide-in-up" style={{
            animationDelay: '200ms'
          }} data-id="element-398">
              <div className="flex items-center gap-2 mb-4" data-id="element-399">
                <BellIcon className="w-5 h-5 text-blue-600" data-id="element-400" />
                <h3 className="text-lg font-semibold text-gray-900" data-id="element-401">
                  Notifications
                </h3>
              </div>
              <div className="bg-gradient-to-br from-gray-50 to-blue-50 rounded-xl p-6 border-2 border-gray-200 transition-all duration-200 hover:shadow-sm hover:border-blue-300" data-id="element-402">
                <p className="text-gray-600 leading-relaxed" data-id="element-403">
                  {t.additionalPreferences}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>;
}